/**
 * Figma 516:18180 workspace fill:
 *   `linear-gradient(180deg, rgba(255,255,255,0.4) 30.769%, rgba(150,222,174,0.4) 100%),
 *    linear-gradient(90deg, #fff, #fff)`
 * The original first gradient only listed a stop at ~31%, which created a flat
 * band then a visible “seam”. We keep the same colours and the white base
 * layer, but add 0% + mid stops so the blend matches Figma intent without the
 * kink.
 */
export const WORKSPACE_PAGE_GRADIENT =
  'linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 22%, rgba(232, 245, 238, 0.4) 48%, rgba(150, 222, 174, 0.4) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)';
